import { IccMaterial } from '@icc/shared/types';
import { FillingVisualization } from './visualization';
import { FillingAccessorySpace } from '@icc/construction-elements/types';

export interface IccFilling {
    id:                     string;
    filling_id?: string;
    extId?: number;
    custom?: boolean;
    fillings_category_id?:   string | number;
    fillings_producer_id:   string | number;
    code:                   string;
    has_glazing_unit:       boolean;
    glazing_unit:           GlazingUnit[] | null;
    comment?:                null | string;
    image?:                  null | string;
    image_in?:                  null | string;
    overlay_type?:           null | string;
    index_no?: string;
    texture?: string;
    overlay_height_texture_mm?: number;
    overlay_width_texture_mm?: number;
    inside_texture?: string;
    overlay_height_inside_texture_mm?: number;
    overlay_width_inside_texture_mm?: number;
    offset_x?: number;
    offset_y?: number;
    color?: string;
    visualizations: Record<number, FillingVisualization>;
    default_colors?:         null | string;
    default_inside_colors?:      null | string;
    price_sq_m:             null | string;
    max_size_m2?:            null | string | number;
    max_width?:              null | string | number;
    max_height?:             null | string | number;
    glazing_count:          string | number;
    thinkness_glass:        null | string | number;
    frame_width:            null | string | number;
    glass_security_inner?:   string;
    glass_security_outer?:   string;
    ornament:               boolean;
    glass_color_id?:         null | string;
    markets?:                string[];
    markets_b2c?:            string[];
    selected_markets?:       string[] | null;
    window_lines_ids?:       string;
    conf:                   ('window' | 'door' | 'side-light' | 'top-light')[];
    order:                  null | number | string;
    parent_id:              null | number | string;
    lft?:                    null | number | string;
    rght?:                   null | number | string;
    created?:                string;
    modified?:               string;
    type:                   IccFillingType;
    panel_type?:             PanelType | null;
    glazing_area?:           string;
    glazing_perimeter?:      string;
    psi?:                    null | string;
    panel_prices?:           null | string;
    filling_details?:        string;
    panel_width_min?:        null | string;
    panel_width_max?:        null | string;
    panel_height_min?:       null | string;
    panel_height_max?:       null | string;
    time_limit_id?:          null | string;
    available_second_color?: boolean;
    available_second_inside_color?: boolean;
    locale?:                 string;
    name:                   string;
    thickness_mm:           number | string;
    overlay_thickness:      number | string;
    always_match_profile:   boolean;
    s?:                      number;
    u:                      number;
    weight?:                 number | null | string;
    rw?:                    number | null | string;
    ctr?:                   number | null | string;
    c?:                     number | null | string;
    lt?:                    number | null;
    g?:                     number | null;
    price?:                 number | null;
    fillings_parent_id?:     null;
    system_types:           IccMaterial[];
    producer?:               string | null;
    minBillingArea:         number;
    selected?:               boolean;
    system_prices?:          any[] | { [key: string]: null | string };
    system_ids:             string[] | null;
    panel_glazings_ids?:     string[];
    door_panel_passive_ids?: string[];
    color_groups_ids?:       string[];
    part_color_groups_ids?:       string[];
    door_model_prices?:      any[];
    thickness_glass?:       number;
    thickness?:             number | string | null;
    is_double_sided?: ('double' | 'single' | 'mixed')[];
    is_flat?:               boolean;
    door_sizes?:          any[] | { [key: string]: any };
    door_sizes_ids?:             string[] | null;

    currentWidth? : number;
    sel_width? : number;
    currentHeight? : number;
    sel_height? : number;
    warmEdge? : number;
    warmEdgeName? : string;

    security_level_outer: SecurityLevels | null;
    security_level_inner: SecurityLevels | null;

    glass_types: GlassTypesFilling[];

    overlay_door_viewer_position_x_mm?: number;
    overlay_door_viewer_position_y_mm?: number;

    max_shortening?: number | null;
    base_side?: string;
    glazing_ids?: number[] | null;
    default_glazing_id?: number | null;
    glazing_to_filter?: boolean;
    size_limit_type?: 'sash' | 'sash_with_frame';
    filling_maps?: FillingMaps
    fillingAccessorySpaces?: FillingAccessorySpace[];
    door_panel_ids: any[];
    isDefault?: boolean;

    doorPanelTrimsOutside?: number[];
    doorPanelTrimsInside?: number[];
    slats?: Slat[];
}

export enum Conf {
    Door = "door",
    Empty = "",
    Window = "window",
}

export interface GlazingUnit {
    id:        number;
    type:      'glass' | 'interPaneSpace';
    value:     number;
    position?: Position;
}

export enum Position {
    Inner = "inner",
    Middle = "middle",
    Outer = "outer",
}

export type PanelType =
    | 'panel_type_inset'
    | 'panel_type_outer'
    | 'panel_type_double'
    | 'panel_type_inner';

export type IccFillingType =
    | 'deco_panels'
    | 'glazing'
    | 'panels_glazing'
    | 'pvc_panels'
    | 'door_panels';


enum SecurityLevels {
    ESG = 'esg',
    O1 = 'o1',
    O2 = 'o2',
    P1A = 'p1a',
    P2A = 'p2a',
    P3A = 'p3a',
    P4A = 'p4a',
    P5A = 'p5a',
    P6B = 'p6b',
    P7B = 'p7b',
    P8B = 'p8b',
}

export interface GlassTypesFilling {
    id: string;
    glass_type_id: string;
    filling_id: string;
    glass_type_variant_id: string;
}

export interface FillingMaps {
    thickness: [];
    thermal_transmittance: [];
}

export interface Slat
{
    id: number;
    slatsId: number[];
    doorSizeId: number;
    ratio: number;
    space: number;
}
